module.exports = __webpack_public_path__ + "img/reward-redeemed.6ae605ef.svg";